import { LOCALES } from '../../../../../constants/locales';
import { LABELS } from '../../../../../constants/subtitle-labels';

import de from './Seo_Services_de-DE.vtt';
import es from './Seo_Services_es.vtt';
import fr from './Seo_Services_fr-FR.vtt';
import it from './Seo_Services_it-IT.vtt';
import nl from './Seo_Services_nl-NL.vtt';
import pt from './Seo_Services_pt-BR.vtt';
import en from './Seo_Services_en-US.vtt';

export default [{
    src: de,
    label: LABELS[LOCALES.DE],
    srcLang: LOCALES.DE
}, {
    src: es,
    label: LABELS[LOCALES.ES],
    srcLang: LOCALES.ES
}, {
    src: fr,
    label: LABELS[LOCALES.FR],
    srcLang: LOCALES.FR
}, {
    src: it,
    label: LABELS[LOCALES.IT],
    srcLang: LOCALES.IT
}, {
    src: nl,
    label: LABELS[LOCALES.NL],
    srcLang: LOCALES.NL
}, {
    src: pt,
    label: LABELS[LOCALES.PT],
    srcLang: LOCALES.PT
}, {
    src: en,
    label: LABELS[LOCALES.EN],
    srcLang: LOCALES.EN
}];
